/**
 * Utility functions for handling channel-specific headers and configurations
 */
import { getWindow } from './general';

/**
 * Determines the appropriate X-Client-App header value based on the channel
 * @param channel - The channel type from experience context
 * @returns The X-Client-App header value
 */
export const getXClientApp = (
  channel: 'desktop' | 'tablet' | 'mobile',
): string => {
  switch (channel) {
    case 'mobile':
    case 'tablet': // Tablets use mobile app
      return 'PHX-Mobile';
    case 'desktop':
    default:
      return 'PHX-Desktop';
  }
};

/**
 * Gets channel information from the experience context
 * Falls back to getWindow().__EXPERIENCE_CONTEXT__.channel if needed
 * @returns The channel value or 'desktop' as fallback
 */
export const getChannelFromContext = (): 'desktop' | 'tablet' | 'mobile' => {
  try {
    // First try to get from window context
    const channel = getWindow()?.__EXPERIENCE_CONTEXT__?.channel;
    if (channel && ['desktop', 'tablet', 'mobile'].includes(channel)) {
      return channel;
    }

    // Fallback to desktop
    return 'desktop';
  } catch {
    return 'desktop';
  }
};
